import { graphql, HttpResponse } from 'msw'
import {
  type UpdateInvestmentEquitiesSectorsOutput,
  type InvestmentEquitiesSectorsRecommendationOutput,
} from '../../../models'

export const investmentEquitiesSectorsRecommendation: InvestmentEquitiesSectorsRecommendationOutput = {
  healthcare: {
    recommendedPercent: 20,
    allowedMinPercent: 15,
    allowedMaxPercent: 30,
    allowedMaxAllocationPercent: 32,
  },
  consumer: {
    recommendedPercent: 20,
    allowedMinPercent: 15,
    allowedMaxPercent: 30,
    allowedMaxAllocationPercent: 32,
  },
  financial: {
    recommendedPercent: 15,
    allowedMinPercent: 5,
    allowedMaxPercent: 25,
    allowedMaxAllocationPercent: 32,
  },
  technology: {
    recommendedPercent: 15,
    allowedMinPercent: 10,
    allowedMaxPercent: 30,
    allowedMaxAllocationPercent: 32,
  },
  industry: {
    recommendedPercent: 10,
    allowedMinPercent: 0,
    allowedMaxPercent: 20,
    allowedMaxAllocationPercent: 32,
  },
  energy: {
    recommendedPercent: 10,
    allowedMinPercent: 0,
    allowedMaxPercent: 20,
    allowedMaxAllocationPercent: 32,
  },
  realEstate: {
    recommendedPercent: 5,
    allowedMinPercent: 0,
    allowedMaxPercent: 15,
    allowedMaxAllocationPercent: 32,
  },
  media: {
    recommendedPercent: 5,
    allowedMinPercent: 0,
    allowedMaxPercent: 15,
    allowedMaxAllocationPercent: 32,
  },
  currentBreakdown: {
    __typename: 'InvestmentEquitiesSectorBreakdown',
    healthcare: 10,
    consumer: 15,
    financial: 15,
    technology: 30,
    industry: 5,
    energy: 5,
    realEstate: 10,
    media: 10,
  },
}

export const updateInvestmentEquitiesSectors: UpdateInvestmentEquitiesSectorsOutput = {
  __typename: 'InvestmentEquitiesSectorBreakdown',
  healthcare: 10,
  consumer: 15,
  financial: 15,
  technology: 30,
  industry: 5,
  energy: 5,
  realEstate: 10,
  media: 10,
}

export const mockInvestmentEquitiesRecommendation = graphql.query('investmentEquitiesSectorsRecommendation', () => {
  return HttpResponse.json({ data: { investmentEquitiesSectorsRecommendation } })
})

export const mockInvestmentEquitiesUpdate = graphql.mutation('updateInvestmentEquitiesSectors', () =>
  HttpResponse.json({ data: { updateInvestmentEquitiesSectors } }),
)

export const mockEquitiesSector = [mockInvestmentEquitiesRecommendation, mockInvestmentEquitiesUpdate]
